<template>
  <div class="list-group-container" ref="group">
    <process-loading
      style="top: 0; bottom: auto"
      ref="groupProcess"
    ></process-loading>
    <div
      class="main-container"
      v-show="!loading && list.length > 0"
      ref="scroller"
    >
      <div class="date-group" v-for="group in groups" :key="group.postTime">
        <div class="date-text">{{ group.postTimeStr }}</div>
        <div
          class="list-item"
          :class="{ lock: item.state === 'post-lock' }"
          v-for="item in group.items"
          :key="item.id"
          @click="itemClick(item)"
        >
          <div
            class="list-image-container"
            :key="item.coverUrl"
            v-lazy:background-image="item.coverUrl"
          >
            <div class="mul-icon" v-show="item.mul"></div>
          </div>
          <div
            class="left-image-container"
            :class="{ story: item.mediaType === 3 }"
          >
            <div
              class="list-image"
              v-lazy:background-image="item.coverUrl"
              :key="item.coverUrl"
            >
              <div class="video-icon" v-show="item.isVideo"></div>
              <div
                class="link-icon"
                v-if="item.mediaType === 90 && item.storyUrl"
              ></div>
              <div class="mul-icon" v-show="item.mul"></div>
            </div>
          </div>
          <div
            class="list-main-container"
            :class="{ story: item.mediaType === 3 }"
          >
            <div class="time-text">
              {{ item.postTimeStr }}
              <template v-if="item.deleteTimeStr"
                >→ {{ item.deleteTimeStr }}</template
              >
            </div>
            <div class="icon-container">
              <div class="icon people" v-show="item.hasPeopleTag"></div>
              <div class="icon location" v-show="item.hasLocation"></div>
              <div class="icon comment" v-show="item.form.firstComment"></div>
              <div class="icon hashtag" v-show="item.hasHashtags"></div>
              <div class="icon mention" v-show="item.hasMentions"></div>
              <div class="icon product" v-show="item.hasProductTag"></div>
            </div>
            <div class="des-text">
              {{ item.caption || "no caption" }}
            </div>
          </div>
          <div class="delete-container" v-show="item.state === 'del-fail'">
            <div class="error-text">DelFail</div>
            <div class="split" v-show="item.mediaType !== 3"></div>
          </div>
          <div
            v-if="item.proofUrl"
            class="delete-container"
            @click.stop="proofClick(item)"
          >
            <div
              class="list-delete-image"
              v-lazy:background-image="item.proofUrl"
              :key="item.proofUrl"
            ></div>
            <div class="split" v-show="item.mediaType !== 3"></div>
          </div>
          <div class="post-info-container" v-show="item.hasPostInfo">
            <div class="info-item">
              <div class="icon like"></div>
              <div class="num-text">{{ item.likeNum | numAbbreviation }}</div>
            </div>
            <div class="info-item" v-show="item.hasVideo">
              <div class="icon view"></div>
              <div class="num-text">{{ item.viewNum | numAbbreviation }}</div>
            </div>
            <div class="info-item" v-if="item.user.social_network === 4">
              <div class="icon forward"></div>
              <div class="num-text">
                {{ item.forwardNum | numAbbreviation }}
              </div>
            </div>
            <div v-else class="info-item">
              <div class="icon common"></div>
              <div class="num-text">
                {{ item.commentNum | numAbbreviation }}
              </div>
            </div>
          </div>
          <div v-show="item.state === 'post-fail'" class="error-text">
            Missed
          </div>
          <template v-if="item.state === 'post-not-auto'">
            <div
              @click.stop="iconClick(item)"
              v-if="
                currentPublisher.socialNetwork === 1 &&
                (item.mediaType === 3 ||
                  item.mediaType === 8 ||
                  item.mediaType === 22 ||
                  !currentPublisher.isBusiness)
              "
              class="not-auto-post"
            >
              <div class="not-auto-icon"></div>
            </div>
            <div @click.stop="iconClick(item)" class="not-auto-post red" v-else>
              <div class="not-auto-icon"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="main-container empty" v-show="!loading && list.length === 0">
      <div class="empty-container">
        <div class="image"></div>
        <div class="tip">Schedule, design, manage your Instagram</div>
      </div>
    </div>
    <div v-show="!loading && total > 0" class="bottom-container">
      <el-pagination
        layout="prev, pager, next"
        :page-size="postLimited"
        @current-change="pageChange"
        :current-page="page"
        :total="total"
      >
      </el-pagination>
    </div>
    <div class="del-modal" v-if="showDelPreviewModal">
      <delete-preview :image="delImage"></delete-preview>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme";

.list-group-container {
  padding: 10px 40px;
  text-align: center;
  flex-direction: column;
  flex: 1;
  display: flex;
  position: relative;
  overflow: scroll;
  .main-container {
    flex: 1;
    overflow: auto;

    &.empty {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #82848a;
      font-size: 14px;

      .empty-container {
        width: 250px;
        position: relative;
        bottom: 70px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: black;
        line-height: 20px;

        .image {
          width: 80px;
          height: 80px;
          background-image: url("../../../../public/images/schedule_posts/list/ic_login_copy.png");
          background-size: contain;
        }

        .tip {
          font-size: 14px;
          margin-top: 10px;
        }
      }
    }

    .date-group {
      text-align: left;
      margin-top: 30px;

      .date-text {
        font-size: 16px;
        font-weight: 500;
      }

      .list-item {
        height: 78px;
        border-radius: 2px;
        border: solid 1px #e6e6e6;
        margin-top: 10px;
        display: flex;
        align-items: center;
        padding: 0 10px 0 7px;
        cursor: pointer;
        width: 780px;
        position: relative;
        &.lock {
          background: #ededed;
          filter: grayscale(1);
        }
        .left-image-container {
          border-radius: 50%;
          width: 62px;
          height: 62px;
          display: flex;
          align-items: center;
          justify-content: center;

          &.story {
            background: linear-gradient(to bottom right, #c6008b, #e1013a);

            .list-image {
              border-radius: 50%;
            }
          }

          .list-image {
            height: 58px;
            width: 58px;
            border: 2px solid white;
            position: relative;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            display: flex;
            align-items: center;
            justify-content: center;

            .mul-icon {
              background-image: url("../../../../public/images/library/album@3x.png");
              width: 15px;
              height: 15px;
              background-size: contain;
              background-position: center;
              position: absolute;
              right: 5px;
              top: 5px;
            }
            .link-icon {
              width: 32px;
              height: 32px;
              background-size: contain;
              background-position: center;
              position: absolute;
              right: -2px;
              top: -2px;
              background-image: url("../../../../public/images/schedule_posts/list/icon_link@3x.png");
            }
            .video-icon {
              width: 35px;
              height: 35px;
              z-index: 2;
              background-size: cover;
              background-image: url("../../../../public/images/schedule_posts/list/video.png");
            }
          }
        }

        .list-main-container {
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 50px;
          flex: 1;
          overflow: hidden;

          &.story {
            justify-content: space-around;

            .des-text {
              display: none;
            }
          }

          .time-text {
            font-size: 14px;
            font-weight: 500;
          }

          .icon-container {
            display: flex;

            .icon {
              height: 14px;
              width: 14px;
              background-size: contain;
              margin-right: 5px;

              &.people {
                background-image: url("../../../../public/images/schedule_posts/list/list_people@3x.png");
              }

              &.location {
                background-image: url("../../../../public/images/schedule_posts/list/list_location@3x.png");
              }

              &.comment {
                background-image: url("../../../../public/images/schedule_posts/list/list_comment@3x.png");
              }

              &.product {
                background-image: url("../../../../public/images/schedule_posts/list/list_product@3x.png");
              }

              &.hashtag {
                background-image: url("../../../../public/images/schedule_posts/list/storylist_Hashtag.png");
              }

              &.mention {
                background-image: url("../../../../public/images/schedule_posts/list/storylist_Mention.png");
              }

              &.location-sticker {
                background-image: url("../../../../public/images/schedule_posts/list/list_location@3x.png");
              }
            }
          }

          .des-text {
            font-size: 12px;
            color: #5a5a5a;
            font-weight: 300;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .delete-container {
          display: flex;
          margin-left: 20px;
          align-items: center;
          .list-delete-image {
            width: 100px;
            height: 58px;
            background-image: url("https://files.apphi.com/1108/posts/77f86c91d188a00da7cea276dd52843a");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }

          .split {
            width: 1px;
            height: 58px;
            background: #e6e6e6;
            margin-left: 20px;
          }
        }

        .post-info-container {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 180px;
          padding-left: 10px;
          .info-item {
            display: flex;
            align-items: center;

            &:first-child {
              margin-left: 0;
            }

            .icon {
              background-size: contain;
              width: 16px;
              height: 16px;
              margin-right: 5px;

              &.like {
                background-image: url("../../../../public/images/schedule_posts/list/icon_like@3x.png");
              }

              &.common {
                background-image: url("../../../../public/images/schedule_posts/list/icon_com@3x.png");
              }
              &.forward {
                background-image: url("../../../../public/images/schedule_posts/list/posted_icon_forward@3x.png");
              }
              &.view {
                background-image: url("../../../../public/images/schedule_posts/list/icon_view@3x.png");
              }
            }

            .num-text {
              font-size: 14px;
            }
          }
        }

        .error-text {
          color: #5a5a5a;
          font-size: 14px;
          text-align: right;
          margin-left: 20px;
        }
        .not-auto-post {
          width: 76px;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          background: #4a4a4a;
          border-radius: 0 2px 2px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          &.red {
            background: #e62b55;
            .not-auto-icon {
              background-image: url("../../../../public/images/banner_icon@3x.png");
            }
          }
          .not-auto-icon {
            background-image: url("../../../../public/images/schedule_posts/list/list-not-auto.png");
            width: 26px;
            height: 26px;
            background-size: contain;
          }
        }
      }
    }
  }

  .bottom-container {
    padding: 10px 0;

    .end-text {
      color: rgb(140, 140, 140);
    }
  }

  .del-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    height: 100vh;
    width: 100vw;
  }
}
</style>

<script>
import moment from "moment-timezone";
import processLoading from "../../../components/common/process/Index";
import {
  getScheduleList,
  getPostedList,
  POST_LIMIT,
  formatPostInfo,
  getFbUrl,
} from "../../../service/post";
import { showErrorMsg } from "../../../utils/errors";
import DeletePreview from "../../../components/media/schedule/detail/DeletePreview";
import { numAbbreviation } from "../../../filters/schedule";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../store/mutation-types";
import { mapGetters } from "vuex";
export default {
  name: "ScheduleListItemComponent",
  components: { DeletePreview, processLoading },
  props: {
    timezone: {
      // 当前时区
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      postLimited: POST_LIMIT, // 每页显示条目
      delImage: "", // 删除图片url
      showDelPreviewModal: false, // 展示删除图片
      list: [], // 实际数据
      total: 0, // 页面总数
      page: -1, // 当前页码
      loading: false, // 是否正在加载中
    };
  },
  filters: { numAbbreviation },
  computed: {
    ...mapGetters({
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    groups() {
      // 转化格式
      const group = formatPostInfo({
        data: this.list,
        timezone: this.timezone,
      });
      // 格式化数据
      return group.map((g) => {
        g.postTimeStr = moment
          .tz(g.postTime, this.timezone)
          .format("MMM DD, YYYY");
        g.items.forEach((i) => {
          i.hasVideo = i.mediaType === 2 || i.mediaType === 3; // 2 或者 3 说明是视频或者story
          i.hasLocation = i.form.location; // 判断是否存在位置信息
          i.hasPeopleTag =
            i.mediaList.findIndex(
              (m) => m.usertags && m.usertags.length > 0
            ) !== -1; // 判断是否存在一个有usertags
          i.hasProductTag =
            i.mediaList.findIndex(
              (m) => m.product_tags && m.product_tags.length > 0
            ) !== -1; // 判断是否存在一个有product_tags
          i.hasPostInfo = this.type === "posted" && i.mediaType !== 3;
          i.hasMentions =
            i.mediaList.findIndex(
              (m) => m.story_mentions && m.story_mentions.length > 0
            ) !== -1; // 判断是否存在一个有story_mentions
          i.hasHashtags =
            i.mediaList.findIndex(
              (m) => m.story_hashtags && m.story_hashtags.length > 0
            ) !== -1; // 判断是否存在一个有story_hashtags
          i.hasLocationSticker =
            i.mediaList.findIndex((m) => {
              if (m.location_sticker) {
                if (
                  m.location_sticker.length &&
                  m.location_sticker.length === 0
                ) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return false;
              }
            }) !== -1; // 判断是否存在一个有story_hashtags
          i.isFail = i.state === "post-fail";
          // 如果失败则不显示post 信息
          if (i.isFail) {
            i.hasPostInfo = false;
          }
          i.mul = i.mediaList.length > 1;
          // 判断是不是视频类型，用于显示播放按钮样式
          i.isVideo = i.mediaList.findIndex((m) => m.type === 2) !== -1;
        });
        return g;
      });
    },
  },
  methods: {
    /**
     * 单条点击事件
     */
    itemClick(item) {
      this.$emit("itemClick", item);
    },
    // 发送失败按钮点击事件
    async iconClick(item) {
      console.log(item);
      this.$bus.$emit("showPostErrorMessage", { item });
    },
    /**
     * 单条删除图片点击事件
     */
    proofClick(item) {
      this.delImage = item.proofUrl;
      this.showDelPreviewModal = true;
    },
    /**
     * 页面变化点击事件
     */
    async pageChange(page) {
      this.page = page;
      this.loading = true;
      if (this.$refs.groupProcess) {
        this.$refs.groupProcess.start();
      }
      try {
        const offset = POST_LIMIT * (page - 1);
        let result = [];
        this.list = [];
        if (this.type === "schedule") {
          result = await getScheduleList({ offset });
        } else {
          result = await getPostedList({ offset });
        }
        for (let i = 0; i < result.results.length; i++) {
          if (
            result.results[i].media_type === 90 &&
            result.results[i].story_url
          ) {
            // 如果存在story url则说明是fb url 替换url中的图片
            const p = await getFbUrl({ url: result.results[i].story_url });
            if (p.image) {
              result.results[i].cover_url = p.image[0].url;
            }
          }
        }
        this.total = result.count;
        this.list = result.results;
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            this.$refs.scroller.scrollTop = 0;
          }
        });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.loading = false;
        if (this.$refs.groupProcess) {
          this.$refs.groupProcess.done();
        }
      }
    },
  },
  mounted() {
    this.pageChange(1);
  },
};
</script>
